import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import SubmenuReportsNavigation from "./components/SubmenuReportsNavigation";
import { OrganizationReportAdjustmentIndexPage } from "./pages/Adjustment";
import { OrganizationReportCorrectionIndexPage } from "./pages/Correction";
import { OrganizationReportInactiveProductIndexPage } from "./pages/InactiveProduct";
import { OrganizationReportPriceIndexPage } from "./pages/Price";
import { OrganizationReportProductIndexPage } from "./pages/Product";
import { OrganizationReportProductSalesIndexPage } from "./pages/ProductSales";
import { OrganizationReportPurchaseIndexPage } from "./pages/Purchase";
import { OrganizationReportSaleIndexPage } from "./pages/Sale";
import { OrganizationReportStateIndexPage } from "./pages/State/Index";
import { OrganizationReportStocktakingIndexPage } from "./pages/Stocktaking";
import { OrganizationReportTransferIndexPage } from "./pages/Transfer";

const OrganizationReportsPage = (props: RouteComponentProps) => {
	return (
		<div className="page-container">
			<SubmenuReportsNavigation />
			<div className="content">
				<Switch>
					<Route path={`${props.match.url}/states`} component={OrganizationReportStateIndexPage} />
					<Route path={`${props.match.url}/products`} component={OrganizationReportProductIndexPage} />
					<Route
						path={`${props.match.url}/sales/products`}
						component={OrganizationReportProductSalesIndexPage}
					/>
					<Route path={`${props.match.url}/purchases`} component={OrganizationReportPurchaseIndexPage} />
					<Route path={`${props.match.url}/sales`} component={OrganizationReportSaleIndexPage} />
					<Route path={`${props.match.url}/transfers`} component={OrganizationReportTransferIndexPage} />
					{/* <Route path={`${props.match.url}/fifo`} component={OrganizationReportFIFOIndexPage} /> */}
					<Route
						path={`${props.match.url}/stocktakings`}
						component={OrganizationReportStocktakingIndexPage}
					/>
					<Route path={`${props.match.url}/prices`} component={OrganizationReportPriceIndexPage} />
					<Route
						path={`${props.match.url}/inactive_products`}
						component={OrganizationReportInactiveProductIndexPage}
					/>
					<Route path={`${props.match.url}/corrections`} component={OrganizationReportCorrectionIndexPage} />
					<Route path={`${props.match.url}/adjustments`} component={OrganizationReportAdjustmentIndexPage} />
					<Redirect from={props.match.url} exact to={`${props.match.url}/states`} />
				</Switch>
			</div>
		</div>
	);
};
export default OrganizationReportsPage;
